import config from 'app-config';

export const tryAuthorize = () => {
  const authUrl = new URL('https://trello.com/1/authorize');
  authUrl.search = new URLSearchParams({
    callback_method: 'fragment',
    response_type: 'fragment',
    return_url: window.location.origin,
    scope: 'read',
    expiration: 'never',
    name: 'Chronos',
    key: config.trelloApiKey,
  });

  return authUrl;
};
